import React, { useState, useEffect, useRef } from "react";
import { Button, Form, Modal, Table } from "react-bootstrap";
import { FaEdit, FaTrashAlt, FaEye } from "react-icons/fa";
import BSPagination from "../../Components/pagination";
import { useNavigate } from "react-router-dom";
import { handleErrors } from "../../services/dataManager";
import {
  deleteNotification,
  getPaginatedNotifs,
  searchNotifications,
  searchNotifsByStatus,
  updateNotifStatus,
} from "../../services/axios/apiManager";
import LoadingSpinner from "../../Components/spinner";
import AddEditNotification from "./addEditNotification";
import NotificationDetailsModal from "./viewNotificationModal";
import { toast } from "sonner";
import $ from "jquery";
import "datatables.net-bs5";
import "datatables.net-bs5/css/dataTables.bootstrap5.min.css";

const NotificationsList = ({
  notifications,
  setNotifications,
  pagination,
  setPagination,
  granted,
}) => {
  const navigate = useNavigate();
  const [query, setQuery] = useState("");
  const [modalOptions, setModalOptions] = useState({});
  const [showOptionsModal, setShowOptionsModal] = useState(false);
  const [addEditModal, openAddEditModal] = useState(false);
  const [selectedNotification, setSelectedNotification] = useState({});
  const [detailsModal, openDetailsModal] = useState(false);
  const [filtering, setFiltering] = useState(false);
  const [status, setStatus] = useState("");
  const tableRef = useRef(null);

  const columns = [
    { data: "title", title: "Title" },
    { data: "type", title: "Type" },
    { data: "target_type", title: "Target type" },
    { data: "priority", title: "Priority" },
  ];

  // // // Fetch paginated list again
  const fetchNotifications = async (pgntn, str = "") => {
    setFiltering(true);
    const res = await getPaginatedNotifs(
      pgntn.currentPage,
      pgntn.pageSize,
      str
    );
    if (res?.data?.success && res?.data?.data) {
      setNotifications(res.data.data);
      if (res?.data?.pagination) {
        setPagination(res.data.pagination);
      }
    } else handleErrors(res, navigate, "Providers list: ");
    setFiltering(false);
  };

  // // // Search
  const handleSearch = async (e) => {
    setFiltering(true);
    const string = e.target.value;
    setQuery(string);
    if (string.length > 0) {
      const res = await searchNotifications(string);
      if (res?.data?.success && res?.data?.data) {
        setNotifications(res.data.data);
      } else {
        handleErrors(res, navigate, "Search Providers: ");
      }
    } else {
      await fetchNotifications(pagination);
    }
    setFiltering(false);
  };

  // // // Search By status
  const handleSearchByStatus = async (e) => {
    setFiltering(true);
    const string = e.target.value;
    setStatus(string);
    if (string.length > 0) {
      const res = await searchNotifsByStatus(string);
      if (res?.data?.success && res?.data?.data) {
        setNotifications(res.data.data);
      } else {
        handleErrors(res, navigate, "Search Providers: ");
      }
    } else {
      await fetchNotifications(pagination);
    }
    setFiltering(false);
  };

  // // // Change page Logic
  const handlePageChange = async (page) => {
    setFiltering(true);
    const temp = { ...pagination };
    setPagination((prev) => ({ ...prev, currentPage: page }));
    temp.currentPage = page;
    fetchNotifications(temp);
    setFiltering(false);
  };

  // // // Delete Modal
  const handleDelete = (notif) => {
    setModalOptions({
      header: "Delete Notification",
      body: `Are you sure you want to delete notification "${notif.title}"?`,
      okay: "Delete",
      method: deleteNotif,
      data: { id: notif.id },
    });
    setShowOptionsModal(true);
  };

  // // // Delete Data Logic
  const deleteNotif = async (data) => {
    setFiltering(true);
    if (data.id) {
      const res = await deleteNotification(data.id);
      if (res?.data?.success) {
        await fetchNotifications(pagination);
        setModalOptions({});
        setShowOptionsModal(false);
      } else {
        handleErrors(res, pagination, "Delete Notification : ");
      }
    }
    setFiltering(false);
  };

  // // // Close Status/Delete Modal
  const handleCloseOptionsModal = () => {
    setModalOptions({});
    setShowOptionsModal(false);
  };

  // // // Open Add/Edit Modal
  const handleOpenAddEditModal = (cat) => {
    setSelectedNotification(cat);
    openAddEditModal(true);
  };

  const resetFilters = async () => {
    setFiltering(true);
    setQuery("");
    setStatus("");
    await fetchNotifications(pagination);
    setFiltering(false);
  };

  // // // Change Status Prompt
  const handleChangeStatus = (notif) => {
    if (!granted?.some((perm) => perm?.type === "toggle-status")) {
      toast.error(
        "You don't have neccessary permissions to do this operation.",
        { duration: 3000 }
      );
      return;
    }
    setModalOptions({
      header: "Change Status",
      body: `Are you sure you want to change the status of "${notif.title}"?`,
      okay: "Change",
      method: changeStatus,
      data: {
        id: notif.id,
        status: notif.status === "draft" ? "sent" : "draft",
      },
    });
    setShowOptionsModal(true);
  };

  const handleOpenDetailsModal = (notif) => {
    setSelectedNotification(notif);
    openDetailsModal(true);
  };

  // // // Delete Data Logic
  const changeStatus = async (data) => {
    setFiltering(true);
    if (data.id) {
      const res = await updateNotifStatus(data);
      if (res?.data?.success) {
        await fetchNotifications(pagination);
        setModalOptions({});
        setShowOptionsModal(false);
      } else {
        handleErrors(res, pagination, "Change Status : ");
      }
    }
    setFiltering(false);
  };

  useEffect(() => {
    if (!tableRef.current) return;
    const dataRows = (notifications || []).map((notif) => {
      const base = columns.map((col) => notif[col.data]);
      const liveStatus = `<p class=\"${notif?.live_id ? "text-success" : notif?.live_error ? "text-danger" : "text-info"}\">${notif?.live_id ? "yes" : notif?.live_error ? "error" : "no"}</p>`;
      const statusBtn = `<button class=\"btn btn-sm status-btn ${
        notif.status === "sent" ? "text-success" : "text-info"
      }\" data-id=\"${notif.id}\" title="change status">${notif.status}</button>`;
      const actionBtns =
        `<button class=\"btn btn-outline-info btn-sm view-btn me-1\" data-id=\"${notif.id}\" title="view details"><i class=\"fas fa-eye\"></i></button>` +
        `${granted?.some((g) => g.type === "update") ? `<button class=\"btn btn-outline-primary btn-sm edit-btn me-1\" data-id=\"${notif.id}\" title="edit"><i class=\"fas fa-edit\"></i></button>` : ""}` +
        `${granted?.some((g) => g.type === "delete") ? `<button class=\"btn btn-outline-danger btn-sm delete-btn\" data-id=\"${notif.id}\" title="delete"><i class=\"fas fa-trash\"></i></button>` : ""}`;
      return [...base, liveStatus, statusBtn, actionBtns];
    });

    const config = {
      data: dataRows, // each row is [...baseFields, statusBtn, actionBtns]
      columns: [
        // six titles taken from your `columns` array:
        ...columns.map((c) => ({ title: c.title })),
        // plus the two button‑columns:
        { title: "live", orderable: false },
        { title: "Status", orderable: false },
        { title: "Actions", orderable: false },
      ],
      destroy: true,
      responsive: true,
      pageLength: pagination.pageSize || 10,
      paging: false,
      searching: false,
    };

    // Initialize or refresh DataTable
    if ($.fn.dataTable.isDataTable(tableRef.current)) {
      $(tableRef.current).DataTable().clear().rows.add(dataRows).draw();
    } else {
      $(tableRef.current).DataTable(config);
    }

    const $tbl = $(tableRef.current);
    $tbl.off("click", ".view-btn").on("click", ".view-btn", function () {
      const id = $(this).data("id");
      const notif = notifications.find((n) => n.id === id);
      handleOpenDetailsModal(notif);
    });
    $tbl.off("click", ".edit-btn").on("click", ".edit-btn", function () {
      const id = $(this).data("id");
      const notif = notifications.find((n) => n.id === id);
      openAddEditModal(true);
      setSelectedNotification(notif);
    });
    $tbl.off("click", ".delete-btn").on("click", ".delete-btn", function () {
      const id = $(this).data("id");
      const notif = notifications.find((n) => n.id === id);
      handleDelete(notif);
    });
    $tbl.off("click", ".status-btn").on("click", ".status-btn", function () {
      const id = $(this).data("id");
      const notif = notifications.find((n) => n.id === id);
      handleChangeStatus(notif);
    });

    return () => {
      $(tableRef.current).DataTable().destroy();
    };
  }, [notifications, pagination.pageSize, granted]);

  return (
    <div className="container py-4 text-light bg-dark p-3 rounded mb-4">
      <div className="row align-items-center mb-4">
        <div className="col-md-8 row">
          <div className="col-md-5">
            <Form.Control
              type="text"
              placeholder="Search..."
              value={query}
              onChange={(e) => {
                handleSearch(e);
              }}
              className="bg-dark text-light border-light input-placeholder-light"
            />
          </div>
          <div className="col-md-5">
            <Form.Select
              name="status"
              value={status}
              onChange={(e) => {
                handleSearchByStatus(e);
              }}
              className="bg-dark border-light text-light"
            >
              <option value="">All Status</option>
              <option className="text-info" value="draft">
                Draft
              </option>
              <option className="text-success" value="sent">
                Sent
              </option>
            </Form.Select>
          </div>
          <div className="col-md-2">
            <div className="row ">
              <Button
                title="Reset Filters And Rrfresh Records"
                className="btn btn-success"
                disabled={filtering}
                onClick={() => {
                  resetFilters();
                }}
              >
                {filtering ? (
                  <LoadingSpinner size={"sm"} variant={"light"} />
                ) : (
                  "Reset"
                )}
              </Button>
            </div>
          </div>
        </div>
        <div className="col-md-4 text-end">
          {granted?.some((perm) => perm?.type === "create") && (
            <Button
              title="Create New Notification"
              className="btn btn-success"
              onClick={() => {
                handleOpenAddEditModal({});
              }}
            >
              <i className="bi bi-plus-circle"></i> Create Notification
            </Button>
          )}
        </div>
      </div>
      <div className="table-responsive">
        <table
          ref={tableRef}
          className="table table-striped w-100 table-dark"
          style={{ whiteSpace: "nowrap" }}
        />
        <div className="constainer-fluid">
          <div className="d-flex justify-content-end">
            <div className="mx-4 py-2">
              <span className="text-light">{`Rows/Page ${pagination.pageSize || 0}, Total records ${pagination?.totalRecords || 0}`}</span>
            </div>
            <BSPagination
              currentPage={pagination?.currentPage}
              totalPages={pagination?.totalPages}
              onPageChange={handlePageChange}
              siblingCount={2}
              showFirstLast={true}
            />
          </div>
        </div>
      </div>
      {/* Details Modal */}
      <NotificationDetailsModal
        detailsModal={detailsModal}
        openDetailsModal={openDetailsModal}
        selectedNotification={selectedNotification}
        setSelectedNotification={setSelectedNotification}
      />
      {/* Add Edit Modal */}
      <AddEditNotification
        addEditModal={addEditModal}
        openAddEditModal={openAddEditModal}
        selectedNotification={selectedNotification}
        setSelectedNotification={setSelectedNotification}
        pagination={pagination}
        fetchNotifications={fetchNotifications}
      />

      <Modal
        show={showOptionsModal}
        onHide={handleCloseOptionsModal}
        centered
        className="text-light"
      >
        <Modal.Header closeButton className="bg-dark text-light border-0">
          <Modal.Title>{modalOptions.header}</Modal.Title>
        </Modal.Header>
        <Modal.Body className="bg-dark text-light">
          {modalOptions.body}
        </Modal.Body>
        <Modal.Footer className="bg-dark text-light border-0">
          <Button variant="secondary" onClick={handleCloseOptionsModal}>
            Cancel
          </Button>
          <Button
            variant="danger"
            onClick={() => {
              modalOptions.method(modalOptions.data);
            }}
          >
            {modalOptions.okay}
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default NotificationsList;
